import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import atoms from 'ctsutheme/components/atoms';
import IconButton from '@material-ui/core/IconButton';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import { withStyles } from '@material-ui/core/styles';
import {
  FasCheckCircle, FasExclamationTriangle, FasExclamationCircle, FasInfoCircle, FasTimes
} from 'assets/icons';
import { RenderElement } from 'components/RenderHelpers';
import { TE } from 'appconstants';

let openSnackbarFn;
const { Tooltip } = atoms;
const variantIcon = {
  success: <FasCheckCircle />,
  warning: <FasExclamationTriangle />,
  error: <FasExclamationCircle />,
  info: <FasInfoCircle />
};

const styles1 = theme => ({
  success: {
    backgroundColor: '#E7FBEE',
    color: '#11612D'
  },
  error: {
    backgroundColor: '#FEDFE7',
    color: '#AB0731'
  },
  info: {
    backgroundColor: '#DFF2FD',
    color: '#05334F'
  },
  warning: {
    backgroundColor: '#FDF8E8',
    color: '#775A09'
  },
  icon: {
    fontSize: 20
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing(1)
  },
  message: {
    display: 'flex',
    alignItems: 'center'
  }
});

function RSSSnackbarContent(props) {
  const {
    classes, className, message, onClose, variant, name, ...other
  } = props;
  const Icon = variantIcon[variant];
  return (
    <RenderElement access>
      <SnackbarContent
        className={`${classNames(classes[variant], className)} py-2 px-3 rounded shadow-lg`}
        aria-describedby="client-snackbar"
        message={(
          <span data-id= {`${TE.ID}_${name}${TE.NOTIFIER}${TE.MSGCONTAINER}`} id="client-snackbar" className={classes.message}>
            {Icon}
            {' '}
&nbsp;&nbsp;&nbsp;
            {message}
          </span>
      )}
        action={[
          <Tooltip
            tooltipplacementtop="true"
            title="Close"
          >
            <IconButton
              key="close"
              aria-label="Close"
              color="inherit"
              data-id= {`${TE.ID}_${name}${TE.NOTIFIER}${TE.CLOSEBTN}`}
              className={`${classes.close} fn-btn close`}
              onClick={onClose}
            >
              <FasTimes />
            </IconButton>
          </Tooltip>
        ]}
        {...other}
      />
    </RenderElement>
  );
}

RSSSnackbarContent.propTypes = {
  className: PropTypes.string,
  message: PropTypes.node,
  onClose: PropTypes.func,
  variant: PropTypes.oneOf(['success', 'warning', 'error', 'info']).isRequired
};

RSSSnackbarContent.defaultProps = {
  className: undefined,
  message: '',
  onClose: null
};

const RSSSnackbarContentWrapper = withStyles(styles1)(RSSSnackbarContent);

const styles2 = theme => ({
  margin: {
    margin: theme.spacing(1)
  }
});

class Notifier extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        open: false,
        message: '',
        variant: ''
    }
  }

  componentDidMount() {
    openSnackbarFn = this.openSnackbar;
  }

  openSnackbar = ({ message, variant }) => {
    this.setState({
      open: true,
      message,
      variant
    });
  };

  handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    this.setState({ open: false });
  };

  render() {
    const { open, variant, message } = this.state;
    return (
      <RenderElement access>
        <div>
          <Snackbar
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left'
            }}
            open={open}
            autoHideDuration={5000}
            onClose={this.handleClose}
          >
            <RenderElement access>
              <RSSSnackbarContentWrapper
                onClose={this.handleClose}
                variant={variant}
                message={message}
              />
            </RenderElement>
          </Snackbar>
        </div>
      </RenderElement>
    );
  }
}

export function openSnackbar({ message, variant }) {
  openSnackbarFn({ message, variant });
}

export default withStyles(styles2)(Notifier);
